import { render } from "./report_templates.html?vue&type=template&id=4fa18b48&external"
import script from "./report_templates.js?vue&type=script&lang=js&external"
export * from "./report_templates.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__